import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Label } from '@videoblocks/design-system';

import { ModelSelect, ModelSelectProps } from '../ModelSelect/ModelSelect';

export type ModelSelectFieldProps = ModelSelectProps;

export const ModelSelectField = ({ className, ...rest }: ModelSelectFieldProps): JSX.Element => {
    return (
        <div className={twMerge('flex flex-col gap-2', className)}>
            <Label htmlFor="model-select" className="text-left" fontSize="sm">
                Model
            </Label>
            <ModelSelect id="model-select" name="model-select" className="w-full max-w-none" {...rest} />
        </div>
    );
};
